import { createSelector } from 'reselect';
import { UserFund } from 'src/types';
import { getDateFrequencyString } from 'src/utils/dates/date-utility';
import { ApplicationState } from '../types';
import { getValidatedSellFundsList } from './sellTransaction.selectors';

export const getSellTransaction = ({ sellTransaction }: ApplicationState) =>
  sellTransaction;

export const getSellTransactionLookup = createSelector(
  [getSellTransaction],
  (sellTransaction) => sellTransaction.sellLookup
);

export const getTotalSell = createSelector(
  [getSellTransactionLookup],
  (transactions) => {
    let totalAmount = 0;
    Object.values(transactions).forEach((fund) => {
      totalAmount += fund.grossAmount;
    });
    return totalAmount;
  }
);

export const getSelectedAccount = createSelector(
  [getSellTransactionLookup, (_, agreementID: string) => agreementID],
  (sellLookup, agreementID: string) => {
    return sellLookup?.[agreementID] || {};
  }
);

export const getGrossUnit = createSelector(
  [getSelectedAccount],
  ({ grossUnit }) => grossUnit
);

export const getGrossAmount = createSelector(
  [getSelectedAccount],
  ({ grossAmount }) => grossAmount
);

export const getSelectedDays = createSelector(
  [getSelectedAccount],
  ({ selectedDays }) => selectedDays
);

export const getSelectedMonths = createSelector(
  [getSelectedAccount],
  ({ selectedMonths }) => selectedMonths
);

export const getFrequencyString = createSelector(
  [getSelectedDays, getSelectedMonths],
  (selectedDays, selectedMonths) =>
    selectedDays?.length && selectedMonths?.length
      ? getDateFrequencyString({ selectedDays, selectedMonths })
      : ''
);

export const getRMDShouldValidate = createSelector(
  [getSellTransaction],
  (transaction) => transaction.rmdShouldValidate
);

export const getAutoSellWithholdingFunds = createSelector(
  [getValidatedSellFundsList, getSellTransactionLookup],
  (validatedFundsList: UserFund[], sellLookup) => {
    return validatedFundsList.filter(
      /* keep only selected and if agreementID exists in sellLookup */
      ({ agreementID, selected }) => selected && agreementID in sellLookup
    );
  }
);
